import { Component, OnInit, SimpleChanges } from '@angular/core';

import { BaseSelectSearch } from './base/base-select-search.component';
import { BaseSelectSearchModule } from './base/base-select.search.module';


@Component({
    selector: 'custom-select-search',
    templateUrl: './base/base-select-search-template.html',
    imports: [
        BaseSelectSearchModule,
    ]
})
export class CustomSelectSearchComponent extends
  BaseSelectSearch implements OnInit {

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.items)
      this.getItemsApi();
  }

  getItemsApi() {
    this.initLoading = false;
    this.isFetchData = true;
    this.items = this.items || [];
    this.setDefaultValue();
  }

}
